import React from 'react';
import { WebinarLink } from './WebinarLink';
export const Problem = ({
  openModal
}) => {
  // Add the openModal prop and the helper function
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-162">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-163">
      <p className="mb-6 leading-relaxed" data-id="element-164">
        Lisa staarde naar de klok aan de keukenmuur. 19:00. Over een uur zou het
        webinar beginnen dat haar vriendin zo aanprees.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-165">
        "90 minuten en je begrijpt eindelijk wat je hond tegen je zegt," had ze
        gezegd. "Klinkt te mooi om waar te zijn, maar het werkte echt."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-166">
        Lisa keek naar Benny, haar 3-jarige bordercollie, die onrustig door de
        woonkamer ijsbeerde. Weer zo'n avond waarin hij niet tot rust kwam,
        waarin elke wandeling eindigde in frustratie, waarin zij zich afvroeg of
        ze wel geschikt was als hondeneigenaar.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-167">
        Ze had alles geprobeerd. Hondenschool, privétrainer, YouTube-video's,
        boeken. Niets leek echt te werken. De problemen kwamen steeds terug.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-168">
        Een webinar van 90 minuten? Kan je echt online in anderhalf leren zien
        wat je hond bedoelt?
      </p>
      <p className="mb-6 leading-relaxed font-semibold text-blue-800" data-id="element-169">
        Om 21:30 wist ze het antwoord.
      </p>
      <div className="w-full mb-6" data-id="element-170">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uzbnXVz3nVptg2L15twYUQ/Scherm_afbeelding_2025-08-15_om_15.32.12_(1)-min.png" alt="Innig moment tussen een vrouw en haar hond die elkaar aandachtig aankijken" className="w-full h-auto rounded-lg shadow-md" data-id="element-171" />
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-172">
          Het moment waarop je eindelijk begrijpt wat je hond al die tijd
          probeerde te zeggen
        </p>
      </div>
      <h2 className="text-xl font-bold text-blue-800 mb-4" data-id="element-173">
        Wat er gebeurt wanneer je plotseling begrijpt wat je hond al maanden
        probeert te zeggen
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-174">
        "Ik snap hem," fluisterde Lisa halverwege het webinar tegen zichzelf.
        Voor het eerst in drie jaar keek ze naar Benny en zag niet chaos, maar
        communicatie.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-175">
        Zijn onrustige heen-en-weer gelopen? Dat was zijn manier om te zeggen
        dat hij mentaal niet moe genoeg was. Die korte blikken naar de deur? Hij
        probeerde haar mee te nemen naar iets interessants. Dat wegkijken
        wanneer ze hem riep? Respect, geen negeren.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-176">
        "Het was alsof iemand plotseling de ondertiteling aanzette bij een
        buitenlandse film," beschrijft Lisa achteraf. "Ineens begreep ik wat er
        al die tijd gebeurde."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-177">
        Lisa is niet de enige. In 2025 volgden meer dan 100.000 Nederlandse en
        Vlaamse hondeneigenaren het gratis webinar "Communiceren met je hond"
        van hondengedragsdeskundige Amee de Bruijn. En week na week stromen de
        verhalen binnen van baasjes die in 90 minuten meer leerden over hun hond
        dan in jaren van traditionele training.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-178">
        Maar hoe kan dit? Hoe kan{' '}
        <a href="https://stresslessdogs.nl/mcc-meta-adv2" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-179">
          dit webinar van 90 minuten
        </a>{' '}
        het verschil maken waar maanden van andere methoden faalden?
      </p>
    </section>;
};